<template>
  <fieldset>
    <legend>Scope of work</legend>
    <div class="checkbox-div">
      <CheckboxGroup :options="allScopes" v-model:checked="model"> </CheckboxGroup>
    </div>

    <div>
      <FormInput :name="'New Scope:'" :placeholder="'Type here..'" v-model="newScope"></FormInput>
      <FormBtn :name="'Add'" @clicked="addNewScope"></FormBtn>
    </div>

    <!--div class="debug">
                <p>model = {{ model }}</p>
                <p>newScope = {{ newScope }}</p>
                <p>scopeOptions = {{ scopeOptions }}</p>
            </div>-->
  </fieldset>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
//import { loadingStart, loadingEnd } from '@/js/common.js';
import { useScopeStore } from '@/stores'
import { storeToRefs } from 'pinia'
import CheckboxGroup from './form/Checkbox-group.vue'
import FormBtn from './form/Form-btn.vue'
import FormInput from './form/Form-input.vue'
const scopeStore = useScopeStore()
//import ScopeController from '../js/idb/ScopeController';
const scopesArr = ['screw piles', 'tall walls', 'concrete foundation', 'steel beam']
const { allScopes } = storeToRefs(scopeStore);
//const scopeOptions = ref([])
//this macro creates a prop 'modelValue' and emits 'update:modelValue'
const model = defineModel('projectScopes')
//const prov = ref();
const newScope = ref()

onMounted(() => {
  console.log('Scopes-checkbox component mounted...')
 // fetchScopes()
})
/*
async function fetchScopes() {
  console.log('Scopes-checkbox.vue fetching all scopes from DB..')
  // loadingStart();
  //const scopes = await ScopeController.fetchAll();
  const scopes = await scopeStore.getAll()
  //const scopes = await DbAdapter.getAllScopes();
  //const idb = await IDBWrapper.create();
  //const scopes = await idb.fetchScopes();
  scopeOptions.value = scopes.map((item) => {
    return item['name']
  })
  //  loadingEnd();
  //console.log("fetched scope options from db, found = " + JSON.stringify(scopeOptions.value));
}*/

async function addNewScope() {
  console.log('Scopes-checkbox.addNewScope()..')
  if (newScope.value != '') {
    // loadingStart();
    // let added = await ScopeController.add(newScope.value);
    let added = await scopeStore.add(newScope.value)
    //let added = await DbAdapter.addScope({ 'name': newScope.value });
    await model.value.push(added.name)
    newScope.value = ''
    //await fetchScopes()
    //loadingEnd();
  }
}
</script>

<style lang="css" scoped>
.checkbox-div {
  max-height: 24rem;
  height: 20rem;
  overflow-x: scroll;
}
</style>
